export default [
    {
        name: 'cadastro-ramo-atividade',
        path: 'ramo-atividade',
        redirect: 'ramo-atividade/index',
        component: () => import(/* webpackChunkName: 'cadastro-ramo-atividade' */ '@/views/cadastro/ramo-atividade/Index'),
        children: [
            {
                meta: {title: 'Lista de ramos de atividade'},
                name: 'cadastro-ramo-atividade-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-ramo-atividade' */ '@/views/cadastro/ramo-atividade/List.vue'),
            },
            {
                meta: {title: 'Cadastro de ramo de atividade'},
                name: 'cadastro-ramo-atividade-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-ramo-atividade' */ '@/views/cadastro/ramo-atividade/Form.vue'),
            },
            {
                meta: {title: 'Edição de ramo-atividade'},
                name: 'cadastro-ramo-atividade-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
                component: () => import(/* webpackChunkName: 'cadastro-ramo-atividade' */ '@/views/cadastro/ramo-atividade/Form.vue'),
            },
        ],
    },
]